import { pxToRem } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Image = styled.img `
  max-width: ${pxToRem(340)};
`;
